import apiClient from './apiClient';

interface User {
  id: number;
  username: string;
  email: string;
  first_name?: string;
  last_name?: string;
  role: string;
  cpf?: string;
  hospital_id?: number;
  hospital_nome?: string;
  telefone?: string;
  ativo: boolean;
  receber_email: boolean;
}

interface UserCreate {
  username: string;
  email: string;
  password: string;
  role: string;
  cpf?: string;
  hospital_id?: number;
  telefone?: string;
}

interface UserUpdate {
  first_name?: string;
  last_name?: string;
  email?: string;
  role?: string;
  cpf?: string;
  hospital_id?: number;
  telefone?: string;
  ativo?: boolean;
  receber_email?: boolean;
}

interface UserFilters {
  role?: string;
}

const userService = {
  getUsers: async (filters: UserFilters = {}): Promise<User[]> => {
    // Build params object, only including non-empty values
    const params: Record<string, string> = {};

    // Only add role param if it's a non-empty string
    if (filters.role && filters.role.trim()) {
      params.role = filters.role;
    }

    // Only send config with params if we have actual filter values
    const config = Object.keys(params).length > 0 ? { params } : {};

    const response = await apiClient.get('/users', config);
    return response.data;
  },

  // Lista auditores ativos para o dropdown "Gerenciar Auditor" da Nova Contagem.
  // Usa endpoint protegido por CONTAGENS_LIST (operacional) em vez de USUARIOS_LIST
  // (admin), para que o perfil AUDITOR consiga montar a contagem pelo calendario.
  getAuditoresDisponiveis: async (): Promise<User[]> => {
    const response = await apiClient.get('/users/auditores-disponiveis');
    return response.data;
  },

  getUser: async (id: number): Promise<User> => {
    const response = await apiClient.get(`/users/${id}`);
    return response.data;
  },

  createUser: async (data: UserCreate): Promise<User> => {
    const response = await apiClient.post('/users', data);
    return response.data;
  },

  updateUser: async (id: number, data: UserUpdate): Promise<User> => {
    const response = await apiClient.put(`/users/${id}`, data);
    return response.data;
  },

  deleteUser: async (id: number): Promise<void> => {
    await apiClient.delete(`/users/${id}`);
  },

  // Helper functions to get related data
  getHospitals: async () => {
    const response = await apiClient.get('/hospitals');
    return response.data;
  },
};

export default userService;
export type { User, UserCreate, UserUpdate, UserFilters };
